import React, { FC } from "react";
import cn from "classnames";
import { useLocation, useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import { Link } from "src/components/Link";
import { Button } from "src/components/Button";
import { PATHNAMES } from "src/constants/routes";
import { ReactComponent as SearchIcon } from "src/assets/icons/search.svg";
import { SearchOptions } from "./SearchOptions";
import { searchTrns } from "./trns";

const DEFAULT_BUTTON_CLASSNAME = "text-purple-base gl:text-xl";
const DEFAULT_SEPARATOR_CLASSNAME =
  "h-px w-6 lg:h-6 lg:w-px bg-purple-base border-0";

interface Props {
  className?: string;
}

export const Search: FC<Props> = ({ className }) => {
  const { t } = useTranslation();

  const location = useLocation();
  const navigate = useNavigate();

  const handleSearch = () => {
    navigate(`${PATHNAMES.CLONES}${location.search}`);
  };

  return (
    <div
      className={cn(
        "flex flex-col lg:flex-row items-center justify-between gap-3 bg-blue-dark-10 p-5 font-medium shadow-purple-base-20 rounded-20",
        className
      )}
    >
      <Link href={PATHNAMES.CLONES} className={DEFAULT_BUTTON_CLASSNAME}>
        {t(searchTrns.viewAll)}
      </Link>

      <hr className={DEFAULT_SEPARATOR_CLASSNAME} />

      <SearchOptions />

      <hr className={DEFAULT_SEPARATOR_CLASSNAME} />

      <Button
        className={cn(DEFAULT_BUTTON_CLASSNAME, "flex gap-2")}
        onClick={handleSearch}
      >
        <SearchIcon />
        <span>{t(searchTrns.search)}</span>
      </Button>
    </div>
  );
};
